import Column from "antd/es/table/Column";
import { useCallback, useState } from "react";
import ColumnGroup from "antd/es/table/ColumnGroup";

const useOverTimeComments = () => {
    const [comments, setComment] = useState([]);
    const [columnInformation, setColumnInformation] = useState({ rows: <></> });

    const updateComments = useCallback((projects = []) => {
        const newComments = projects.map((project) => {
            const { name, overtimecomments, percentage } = project;
            const commentsBase = {
                technical_knowledge: {
                    comment: "SIN COMENTARIO",
                    score: 0,
                },
                quality: {
                    comment: "SIN COMENTARIO",
                    score: 0,
                },
                missing_documentation: {
                    comment: "SIN COMENTARIO",
                    score: 0,
                },
                technical_difficulty: {
                    comment: "SIN COMENTARIO",
                    score: 0,
                },
                quotation: {
                    comment: "SIN COMENTARIO",
                    score: 0,
                },
                provider: {
                    comment: "SIN COMENTARIO",
                    score: 0,
                },
                negotiation: {
                    comment: "SIN COMENTARIO",
                    score: 0,
                },
                management_monitoring: {
                    comment: "SIN COMENTARIO",
                    score: 0,
                },
                pause: {
                    comment: "SIN COMENTARIO",
                    score: 0,
                },
            };

            overtimecomments.forEach((comment) => {
                commentsBase[comment.reason].comment = comment.comment;
                commentsBase[comment.reason].score = comment.score;
            });

            return {
                key: project._id,
                name,
                percentage,
                negotiationComment: commentsBase.negotiation.comment,
                negotiationScore: commentsBase.negotiation.score,
                quotationComment: commentsBase.quotation.comment,
                quotationScore: commentsBase.quotation.score,
                technical_knowledgeComment: commentsBase.technical_knowledge.comment,
                technical_knowledgeScore: commentsBase.technical_knowledge.score,
                qualityComment: commentsBase.quality.comment,
                qualityScore: commentsBase.quality.score,
                missing_documentationComment: commentsBase.missing_documentation.comment,
                missing_documentationScore: commentsBase.missing_documentation.score,
                technical_difficultyComment: commentsBase.technical_difficulty.comment,
                technical_difficultyScore: commentsBase.technical_difficulty.score,
                providerComment: commentsBase.provider.comment,
                providerScore: commentsBase.provider.score,
                management_monitoringComment: commentsBase.management_monitoring.comment,
                management_monitoringScore: commentsBase.management_monitoring.score,
                pauseComment: commentsBase.pause.comment,
                pauseScore: commentsBase.pause.score,
            };
        });
        setComment(newComments);
    }, []);

    const updateColumnInformation = useCallback((tabKey) => {
        const columnsData = {
            "Operaciones-comercial": {
                rows: (
                    <>
                        <ColumnGroup width={300} title="Negociación">
                            <Column align="center" title="Valor" width={80} dataIndex="negotiationScore" key="negotiationScore" />
                            <Column align="center" title="Comentario" dataIndex="negotiationComment" key="negotiationComment" />
                        </ColumnGroup>
                        <ColumnGroup width={300} title="Cotización">
                            <Column align="center" title="Valor" width={80} dataIndex="qualityScore" key="qualityScore" />
                            <Column align="center" title="Comentario" dataIndex="quotationComment" key="quotationComment" />
                        </ColumnGroup>
                        <ColumnGroup width={300} title="Pausa">
                            <Column align="center" title="Valor" width={80} dataIndex="pauseScore" key="pauseScore" />
                            <Column align="center" title="Comentario" dataIndex="pauseComment" key="pauseComment" />
                        </ColumnGroup>
                    </>
                ),
            },
            "Operaciones-areas": {
                rows: (
                    <>
                        <ColumnGroup width={300} title="Calidad">
                            <Column align="center" title="Valor" width={80} dataIndex="qualityScore" key="qualityScore" />
                            <Column align="center" title="Comentario" dataIndex="qualityComment" key="qualityComment" />
                        </ColumnGroup>

                        <ColumnGroup width={300} title="Dificultad técnica no prevista">
                            <Column align="center" title="Valor" width={80} dataIndex="technical_difficultyScore" key="technical_difficultyScore" />
                            <Column align="center" title="Comentario" dataIndex="technical_difficultyComment" key="technical_difficultyComment" />
                        </ColumnGroup>
                        <ColumnGroup width={300} title="Conocimiento técnico">
                            <Column align="center" title="Valor" width={80} dataIndex="technical_knowledgeScore" key="technical_knowledgeScore" />
                            <Column align="center" title="Comentario" dataIndex="technical_knowledgeComment" key="technical_knowledgeComment" />
                        </ColumnGroup>
                    </>
                ),
            },
            Operaciones: {
                rows: (
                    <>
                        <ColumnGroup width={300} title="Seguimiento gestión">
                            <Column align="center" title="Valor" width={80} dataIndex="management_monitoringScore" key="management_monitoringScore" />
                            <Column align="center" title="Comentario" dataIndex="management_monitoringComment" key="management_monitoringComment" />
                        </ColumnGroup>
                        <ColumnGroup width={300} title="Falta de documentación">
                            <Column align="center" title="Valor" width={80} dataIndex="missing_documentationScore" key="missing_documentationScore" />
                            <Column align="center" title="Comentario" dataIndex="missing_documentationComment" key="missing_documentationComment" />
                        </ColumnGroup>
                        <ColumnGroup width={300} title="Proveedor">
                            <Column align="center" title="Valor" width={80} dataIndex="providerScore" key="providerScore" />
                            <Column align="center" title="Comentario" dataIndex="providerComment" key="providerComment" />
                        </ColumnGroup>
                    </>
                ),
            },
        };
        setColumnInformation({ columns: columnsData[tabKey].columns, rows: columnsData[tabKey].rows });
    }, []);

    return { comments, updateComments, updateColumnInformation, columnInformation };
};

export default useOverTimeComments;
